import EventsPage from './EventsPage';

export default EventsPage;
